import * as React from 'react';
import * as styles from './Card.css';

interface ICardProps {
  footer?: React.ReactNode;
}

export function Card({ children, footer }: React.PropsWithChildren<ICardProps>): React.JSX.Element {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>{children}</div>
      {footer && <div className={styles['footer']}>{footer}</div>}
    </div>
  );
}
